.firstScreenWrapper {
  background: #fffbf1;
  padding-top: 20px;
  position: relative;
}

.firstScreenWrapperV2 {
  background: #fffbf1;
  padding-top: 60px;
}

.timerWrapper {
  margin-top: 24px;
  position: sticky;
  top: 0;
  z-index: 2;
}

.timerWrapperPuppy {
  position: sticky;
  top: 0;
  z-index: 2;
}

.timerWrapperV2 {
  position: sticky;
  top: 0;
  z-index: 2;
}

.reviewsWrapper {
  margin-top: 24px;
  padding: 0 20px;
}

.barChartWrapper {
  margin-top: 10px;
  padding: 0 20px;
}

.benefitsWrapper {
  margin-top: 32px;
  padding: 0 20px;
}

.offerWrapper {
  margin-top: 24px;
}

.offerWrapper2 {
  margin-top: 0px;
}

.polycyWrapper {
  padding: 0 20px;
  margin-top: 20px;
}

.getMyplanWrapper {
  margin-top: 12px;
}

.getMyplanWrapper2 {
  margin-top: 12px;
}

.supportBlockWrapper {
  margin-top: 32px;
  padding: 0 20px;
}

.ReviewsSliderWrapper {
  margin-top: 32px;
  overflow: hidden;
}

.imgWrapper {
  margin-top: 32px;
}

.infoBlockWrappre {
  margin-top: 50px;
  margin-bottom: 50px;
}

.informationWrapper {
  padding: 0 20px;
  margin-top: 8px;
  margin-bottom: 32px;
}

.guaranteeWrapper {
  padding: 0 20px;
  margin-top: 32px;
  margin-bottom: 84px;
}

.optionsWrapper {
  padding: 0px 20px 0 20px;

  .optionsTitle {
    color: #231e19;
    text-align: center;
    font-family: ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
      sans-serif;
    font-size: 28px;
    font-weight: 700;
    line-height: 34px;
    letter-spacing: -0.4px;
    margin-bottom: 24px;
  }

  .options {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 16px;
  }

  .option {
    display: flex;
    position: relative;
    align-items: center;
    justify-content: space-between;
    height: 80px;
    border-radius: 8px 24px 24px 24px;
    background: rgba(243, 237, 223, 0.5);
    box-sizing: border-box;
    padding-left: 56px;
    padding-right: 8px;
    cursor: pointer;

    &__selected::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 8px 24px 24px 24px;
      border: 3px solid #c85bff;
    }
  }

  .radio {
    border-radius: 39px;
    border: 2px solid #ded9ce;
    border: 2px solid color(display-p3 0.868 0.85 0.8103);
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    position: absolute;
    top: 50%;
    left: 16px;
    transform: translate(0, -50%);
  }

  .priceWrapeprTitle {
    color: #231e19;
    font-family: ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
      sans-serif;
    font-size: 17px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0.068px;
    margin-bottom: 4px;
    text-transform: uppercase;

    @media (max-width: 375px) {
      @at-root html[lang='ru'] & {
        font-size: 14px;
      }

      @at-root html[lang='fr'] & {
        font-size: 15px;
      }

      @at-root html[lang='es'] & {
        font-size: 15px;
      }

      @at-root html[lang='pt'] & {
        font-size: 15px;
        line-height: 17px;
      }

      @at-root html[lang='it'] & {
        font-size: 14px;
      }

      @at-root html[lang='pl'] & {
        font-size: 15px;
      }

      @at-root html[lang='uk'] & {
        font-size: 15px;
      }
    }

    @media (max-width: 360px) {
      @at-root html[lang='fr'] & {
        font-size: 13px;
        line-height: 16px;
      }
    }
  }

  .price {
    color: #231e19;
    font-size: 12px;
    font-weight: 510;
    line-height: 16px;
    letter-spacing: 0.036px;

    span {
      color: #7b766f;
      font-weight: 400;
      letter-spacing: -0.036px;
      text-decoration: line-through;
    }

    .lineRed {
      text-decoration-color: red;
    }
  }

  .priceDay {
    position: relative;
    background: url(./img/grey.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    width: 98px;
    height: 66px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .oldPriceDay {
    position: absolute;
    top: 0;
    left: -20px;
    color: #7b766f;
    font-size: 11px;
    font-weight: 590;
    line-height: 13px;
    letter-spacing: -0.3px;
    text-decoration: line-through;
  }

  .dollar {
    position: absolute;
    left: 20px;
    top: 18px;
    transform: translate(0, -50%);
    color: #231e19;
    font-family: ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
      sans-serif;
    font-size: 18px;
    font-weight: 800;
    line-height: 20px;
    letter-spacing: -0.4px;
  }

  .firstPart {
    color: #231e19;
    font-family: ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
      sans-serif;
    font-size: 34px;
    font-weight: 800;
    line-height: 41px;
    letter-spacing: -0.4px;
    margin-left: 30px;
  }

  .small {
    display: flex;
    flex-direction: column;
  }

  .secondPart {
    color: #231e19;
    font-family: ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
      sans-serif;
    font-size: 18px;
    font-weight: 800;
    line-height: 20px;
    letter-spacing: -0.4px;
  }

  .priceDayText {
    color: #231e19;
    font-size: 11px;
    font-weight: 400;
    line-height: 13px;
    letter-spacing: -0.3px;
  }

  .label {
    position: absolute;
    top: 0;
    transform: translate(0, -50%);
    left: 47px;
    border-radius: 24px;
    background:  #F0930C;
    box-shadow: 1px -3px 16px 0 rgba(255, 255, 255, 0.60) inset;
    z-index: 1;
    padding: 4px 12px;
    color: #FFFBF2;
    font-family: ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
      sans-serif;
    font-size: 10px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0.04px;
    text-transform: uppercase;
  }

  .labelDiscount {
    padding: 2px 4px;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 8px 0;
    background: #F83800;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFF;
    font-family: ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto', sans-serif;
    font-size: 10px;
    font-weight: 800;
    line-height: 14px;
    letter-spacing: 0.4px;
    text-transform: uppercase;
  }

  .option__selected {
    .radio {
      background: url(./img/radio.png);
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      border: none;
    }

    .priceDay {
      background: url(./img/label_active.png);
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
    }

    .dollar,
    .firstPart,
    .secondPart,
    .priceDayText {
      color: #fffbf1;
    }
  }
}

.optionsWrapper.secondScreenWrapper {
  .option {
    background: #f3eddf;
  }
}

.optionsWrapper.tariffV5.secondScreenWrapper {
  .optionsTitle {
    color: #fffbf1;
  }
}

.optionStyleV2 {
  .option {
    padding-right: 16px;

    .bestOffer {
      letter-spacing: -0.5px;
    }
  }

  .price .lineRed {
    text-decoration-color: #7b766f;
  }

  .priceWrapeprTitle {
    text-transform: none;
    font-weight: 600;
  }

  .priceDay {
    background: none;
    width: 107px;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;

    .priceDayWrapper {
      margin-top: 4px;
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }

    .firstPart {
      margin: 0;
      color: #231e19;
      text-align: right;
      font-family: ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
        sans-serif;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 41px;
      letter-spacing: -0.4px;
      display: flex;
      justify-content: flex-end;
    }

    .dollar {
      position: relative;
      top: 0;
      left: 0;
      display: inline-flex;
      transform: none;
      line-height: 25px;
    }

    .priceDayText {
      text-align: right;
      color: #7b766f;
      font-size: 11px;
      font-style: normal;
      font-weight: 400;
      line-height: 13px;
      letter-spacing: -0.3px;
      position: relative;
      top: -3px;
    }
  }

  .option__selected {
    &::after {
      border: none;
      box-shadow: 0 0 0 3px #c85bff;
    }

    .priceDay {
      background: none;

      .dollar {
        // color: #ba61fe;
        font-weight: 900;
        color: transparent;
        background: linear-gradient(180deg, #fff 0%, #ba61fe 40%, #ba61fe 100%);
        -webkit-background-clip: text;
        background-clip: text;
      }

      .firstPart {
        // color: #ba61fe;
        font-weight: 900;
        color: transparent;
        background: linear-gradient(180deg, #fff 0%, #ba61fe 40%, #ba61fe 100%);
        -webkit-background-clip: text;
        background-clip: text;
      }
    }
  }
}

.priceWrapeprTitle.priceWrapeprTitleV2 {
  margin: 0;
  font-size: 19px;
  line-height: 24px;
}

.oldPricePerDay {
  position: absolute;
  right: 14px;
  top: 0;
  color: #7a7670;
  text-align: right;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 13px;
  letter-spacing: -0.3px;
  text-decoration: line-through;
}

.optionStyleCustom {
  .options .option {
    padding-right: 8px;
  }

  .options .dollar {
    top: -3px;
  }
}

// Dark mode
:global body.dark {
  :local {
    .firstScreenWrapper,
    .firstScreenWrapperV2 {
      background-color: #181716;
    }

    .optionsTitle,
    .priceWrapeprTitle,
    .price {
      color: #fffbf2;
    }

    .option {
      background-color: #2a2928;
    }

    .priceDay {
      .firstPart,
      .dollar {
        color: #fffbf2;
      }
    }

    .radio {
      border-color: #7b766f;
    }

    .priceDayText,
    .lineRed {
      color: #8b8984;
    }

    .optionsWrapper.tariffV5 {
      .option {
        background: #2a2928;
      }
    }

    .option__selected {
      .priceDay {
        background: none;

        .firstPart, .dollar {
          background: #ba61fe;
          -webkit-background-clip: text;
          background-clip: none;
        }
      }
    }
  }
}
